import { Component, inject, model } from '@angular/core';
import { Observable } from 'rxjs';

import { BarChartAxisType } from '../../../models';
import { ModalService } from '../../../services';
import { LineChartComponent } from '../../charts/line-chart/line-chart.component';

@Component({
  selector: 'app-line-chart-modal',
  templateUrl: './line-chart-modal.component.html',
  styleUrl: './line-chart-modal.component.css',
  imports: [LineChartComponent],
})
export class LineChartModalComponent<T> {
  private readonly modalService = inject(ModalService);

  public readonly yAxisName = model('');
  public readonly xKey = model('');
  public readonly yKey = model('');
  public readonly yKey2 = model('');
  public readonly header = model('');
  public readonly xAxisName = model('');
  public readonly yName = model('');
  public readonly yName2 = model('');
  public readonly yFormat = model<BarChartAxisType>();
  public readonly xRotation = model<number>();
  public readonly data$ = model<Observable<T[]>>();

  onClose() {
    this.modalService.dismiss();
  }
}
